import React, {useState} from 'react';
import {styled} from '@mui/system';
import {Button} from '@mui/material';

interface ExpandableIconButtonProps {
  title: string;
  startIcon?: JSX.Element;
  onClick: () => void;
  disabled?: boolean;
  color: 'primary' | 'secondary';
  variant?: 'contained' | 'outlined';
}

const ExpandableButton = styled(Button)(() => ({
  transition: 'width 0.3s ease',
  minWidth: '60 px',//  Small square when not hovered// Ensures the button is a square
  overflow: 'hidden',
  height: '50px',
  whiteSpace: 'nowrap',
  paddingLeft: '10px',
  paddingRight: '10px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const ExpandableIconButtonComponent = (props: ExpandableIconButtonProps) => {
  const {title, startIcon, onClick, disabled = false, variant = 'contained', color = 'primary'} = props;
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <ExpandableButton
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}
      onClick={onClick}
      sx={{
        width: hovered ? `${Math.max(100, Math.min(300, 10 * title.length))}px` : '38px',
      }}
      variant={variant}
      color={color}
      startIcon={hovered ? startIcon : null}  // Show icon on the left when hovered
    >
      {!hovered ? startIcon : title}
    </ExpandableButton>
  );
};

export default ExpandableIconButtonComponent;
